import { render, staticRenderFns } from "./CompanyManage.vue?vue&type=template&id=634d74a6&"
import script from "./CompanyManage.vue?vue&type=script&lang=js&"
export * from "./CompanyManage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyManage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports